module.exports = __webpack_public_path__ + "static/media/icon_wifi-success.9d869b6d.svg";